import {
  RooftopMapStatisticsDto,
  RooftopStatisticsDto,
  RooftopAdminFindOneDto,
  Pagination,
  PaginationQuery,
} from '@libs/dto';
import { Rooftop } from '@libs/models';

import { api } from '../common.api';

export const adminRooftopApi = api.injectEndpoints({
  endpoints: (build) => ({
    rooftopStatistics: build.query<RooftopStatisticsDto, void>({
      query: () => ({
        url: '/rooftop/admin/statistics',
        method: 'GET',
      }),
    }),
    rooftopMapStatistics: build.query<RooftopMapStatisticsDto, void>({
      query: () => ({
        url: '/rooftop/admin/map-statistics',
        method: 'GET',
      }),
    }),
    rooftopAdminSearch: build.query<Pagination<Rooftop>, PaginationQuery & { isConfidential?: boolean }>({
      query: ({ q, id, page = 1, limit = 10, isConfidential }) => ({
        url: '/rooftop/admin/search',
        method: 'GET',
        params: { q, page, limit, id, isConfidential },
      }),
      providesTags: ['Rooftop'],
    }),
    rooftopAdminFindOne: build.query<RooftopAdminFindOneDto, string>({
      query: (id) => ({
        url: `/rooftop/admin/${id}`,
        method: 'GET',
      }),
      providesTags: ['Rooftop'],
    }),
  }),
});

export const {
  useRooftopStatisticsQuery,
  useRooftopMapStatisticsQuery,
  useRooftopAdminSearchQuery,
  useLazyRooftopAdminSearchQuery,
  useRooftopAdminFindOneQuery,
} = adminRooftopApi;
